// extracted by mini-css-extract-plugin
export default {"main_wrapper":"TestDashbord_main_wrapper__Pimds","sideBarToogle":"TestDashbord_sideBarToogle__qivlH"};